import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import FuseLoading from "@fuse/core/FuseLoading";
import SupervisorReportsItem from "./SupervisorReportsItem";
import { ApiReport, endpoints_report } from "src/app/api/reportApi";
import { useSelector } from "react-redux";
import { selectUser } from "app/store/userSlice";
import { useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";

export default function SupervisorReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const api = new ApiReport();
  const user = useSelector(selectUser);

  const getReports = async () => {
    try {
      const response = await api.get(
        endpoints_report.REPORTBYSUPERVISORHISTORICO,
        user.data.id
      );
      // ordeno por fecha (más reciente primero)
      const sorted = (response || []).slice().sort((a, b) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      });
      setReports(sorted);
    } catch (error) {
      console.error("Error al obtener reportes:", error);
      setReports([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getReports();
  }, [location]);

  if (loading) return <FuseLoading />;

  return (
    <motion.div
      initial={{ y: 16, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.12 } }}
      className="flex flex-col w-full max-h-full"
    >
      {reports.length === 0 ? (
        <Typography variant="h6" align="center" color="text.secondary" sx={{ mt: 4 }}>
          No se encontraron reportes para este cliente.
        </Typography>
      ) : (
        <Box display="grid" gap={2} p={2} sx={{
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr"
          }
        }}>
          {reports.map((report) => (
            <SupervisorReportsItem key={report.id} report={report} />
          ))}
        </Box>
      )}
    </motion.div>
  );
}
